import React from 'react'
import PageEmpty from './PageEmpty'

export default function ExpandableListWrapper({ children, isEmpty }: { children: React.ReactNode; isEmpty: boolean }) {
  if (isEmpty) {
    return <PageEmpty />
  }
  return <div className="flex flex-col gap-3">{React.Children.toArray(children)}</div>
}
